import { EventEmitter, Injectable } from '@angular/core';
import { fromEvent, pipe } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  tap,
} from 'rxjs/operators';
import { ScreenJSON } from '../../interfaces/screen.interface';

// const MOBILE_MAX_WIDTH = 425  // Adjust as needed
const MOBILE_MAX_WIDTH = 768; // Adjust as needed
const TABLET_MAX_WIDTH = 1024; // Adjust as needed

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  screen$ = new EventEmitter<any>();

  constructor() {}

  /**
   * Watch display width resize event.
   */
  init() {
    this.setWindowWidth(window.innerWidth);

    fromEvent(window, 'resize')
      .pipe(
        debounceTime(50),
        pipe(
          distinctUntilChanged(),
          startWith(window.innerWidth),
          map(() => window.innerWidth),
          tap((width) => this.setWindowWidth(width))
        )
      )
      .subscribe((res) => {});
  }

  /**
   * Set alert event with new display width (phone, desktop, etc).
   *
   * @param windowWidth
   */
  setWindowWidth(windowWidth: number): void {
    const mobile = windowWidth <= MOBILE_MAX_WIDTH;
    const tablet =
      windowWidth <= TABLET_MAX_WIDTH && windowWidth > MOBILE_MAX_WIDTH;
    const screenData: ScreenJSON = {
      mobile,
      tablet,
      desktop: !mobile && !tablet,
    };
    localStorage.setItem('screen', JSON.stringify(screenData));
    this.isMobile();
    this.isDesktop();
    this.isTablet();
    this.screen$.emit(screenData);
  }

  /**
   * Get screen width.
   */
  getScreen(): ScreenJSON {
    return JSON.parse(localStorage.getItem('screen') || '');
  }

  /**
   * Check if is mobile screen.
   */
  isMobile() {
    return this.getScreen()?.mobile;
  }

  /**
   * Check if is desktop screen.
   */
  isTablet() {
    return this.getScreen()?.tablet;
  }

  /**
   * Check if is desktop screen.
   */
  isDesktop() {
    return this.getScreen()?.desktop;
  }
}
